import * as Contentful from 'contentful';

const ContentfulAPI = 
  Contentful.createClient({
    space: process.env.VUE_APP_CONTENT_SPACE,
    accessToken: process.env.VUE_APP_CONTENT_ACCESS_TOKEN,
    environment:  'master',
  });

export default ContentfulAPI;